import { CardComponent, SpectrumTabs } from "components";
import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card } from "react-bootstrap";
import Container from "react-bootstrap/esm/Container";
import "./GNSSSpectrum.css";
import { Ring } from "react-awesome-spinners";
import { useLocation } from "react-router-dom";

import { useGnssApi, useFilter } from "utils/hooks";
import { InterferencesTable } from "../../components/tables/InterferencesTable";

import { WarningCard, LoadingSpinner } from "../../components";

//var counter = 0;

export const GNSSSpectrum = () => {
  const api = useGnssApi();
  const location = useLocation();
  const { groupFilter } = useFilter();

  const cardRefs = useRef([]);
  const [expandedItems, setExpandedItems] = useState([]);
  const [stationsDetails, setStationsDetails] = useState([]);
  const [lastExpandedIndex, setLastExpandedIndex] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [warning, setWarning] = useState({ title: "", message: "" });

  // Fetch station data on mount
  useEffect(() => {
    const fetchStations = async () => {
      try {
        setIsLoading(true);
        let response = await api.getAllStationsDetails();
        response = response.data;
        setIsLoading(false);
        response = response.filter((station) =>
          station.groupNames.some(
            (groupName) => !groupFilter.includes(groupName)
          )
        );
        setStationsDetails(response ?? []);

        if (response.length === 0) {
          setIsSuccess(false);
          setWarning({
            title: "No stations available",
            message: `Your administrator hasn’t granted you access to the stations. Please contact your administrator to request the required permissions.  
  If you are the administrator, please ensure that your account has the necessary permissions and that at least one network and receiver are configured in the platform settings.`,
          });
        } else setIsSuccess(true);
      } catch (e) {
        setIsLoading(false);
        //console.error("Failed to fetch stations", e);

        setIsSuccess(false);
        setWarning({
          title: "No stations available",
          message: `Your administrator hasn't granted you access to the stations. If you are the administrator please check that you have networks and stations added in platform  `,
        });
      }
    };
    fetchStations();
  }, []);

  useEffect(() => {
    if (location.state?.identifier) {
      // Scroll to the item matching the key passed via location.state
      const index = stationsDetails?.findIndex(
        (s) => s.identifier === location.state?.identifier
      );

      if (index !== -1 && cardRefs.current[index]) {
        setExpandedItems((prev) => ({
          ...prev,
          [index]: true,
        }));
        setLastExpandedIndex(index);
      }
    }
  }, [location, stationsDetails]);

  useEffect(() => {
    if (lastExpandedIndex !== null && cardRefs.current[lastExpandedIndex]) {
      const element = cardRefs.current[lastExpandedIndex];
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [expandedItems, lastExpandedIndex]);

  const handleExpand = (index, state) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: state,
    }));

    setLastExpandedIndex(index);
  };

  if (isLoading) return <LoadingSpinner />;

  if (!isSuccess && !isLoading) return <WarningCard {...warning} />;

  return (
    <Row className="m-0">
      <div className="grid-spectrum">
        {stationsDetails &&
          stationsDetails &&
          stationsDetails?.map((station, index) => {
            return (
              <div
                key={index}
                ref={(el) => (cardRefs.current[index] = el)}
                style={{
                  gridColumn: expandedItems[index] ? "span 2" : "span 1",
                }}
              >
                <CardComponent
                  title={station.name}
                  isExpanded={expandedItems[index] || false}
                  onExpand={(state) => handleExpand(index, state)}
                  subtitle={
                    station.groupNames &&
                    station.groupNames.length < 2
                      ? `${station.identifier} (${station.groupNames[0]})`
                      : `${station.identifier} (${
                          station.groupNames[0]
                        } and ${
                          station.groupNames.length - 1
                        } more networks)`
                  }
                  icon={"../img/tower.png"}
                >
                  <SpectrumTabs
                    stationInfo={station}
                    isExpanded={expandedItems[index] || false}
                  />
                </CardComponent>
              </div>
            );
          })}
      </div>
    </Row>
  );
};
